/**
 * Project : workspace
 * File    : OrderBusinessCard.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package component.order

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ExpandLess
import androidx.compose.material.icons.filled.ExpandMore
import androidx.compose.material.icons.rounded.QuestionMark
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.parmartechnologies.business.feature.business.utill.AddressUtill
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.business.feature.businessConfig.handler.BusinessConfigHandler
import com.parmartechnologies.commerce.feature.alert.handler.AlertHandler
import com.parmartechnologies.commerce.feature.alert.viewModel.AlertViewModel
import com.parmartechnologies.commerce.feature.order.viewModel.OrderViewModel
import com.parmartechnologies.core.feature.business.model.Business
import com.parmartechnologies.core.feature.order.model.Order
import com.parmartechnologies.core.feature.order.reason.OrderReason
import com.parmartechnologies.core.feature.order.status.OrderStatus
import com.parmartechnologies.ui.component.image.ImageView
import component.alert.AlertDialogue
import component.button.DefaultButton
import component.button.SecondaryButton
import component.input.TextInputField
import component.visual.DottedLine
import engine.date.DateEngine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch
import locale.localization
import navigation.AppNavigator
import theme.ThemeColor
import kotlin.time.ExperimentalTime

@OptIn(ExperimentalTime::class)
@Composable
        /**
         * Executes the order business card operation.
         *
         * @receiver TODO
         * @param business The business.
         * @param order The order.
         * @param viewModel The view model.
         * @param onClick The on click.
         * @return Unit – no return value.
         */
fun OrderBusinessCard(
    business: Business,
    order: Order,
    viewModel: BusinessViewModel,
    onClick: (Order) -> Unit
) {
    val orderViewModel = OrderViewModel(business)
    val alertViewModel = AlertViewModel()
    var business: Business? by remember { mutableStateOf(null) }
    var isExpanded by remember { mutableStateOf(false) }
    val selectedOrderId = remember<MutableState<String?>> { mutableStateOf(null) }
    val description = remember { mutableStateOf("") }
    LaunchedEffect(key1 = Unit) {
        if (order.selectedBusinessID.isNotEmpty()) {
            viewModel.getBusinessById(order.selectedBusinessID) {
                business = it
            }
        }
    }
    val (orderStatusChangeTitle, orderStatusChangeState) = when (order.status) {
        OrderStatus.PLACED -> "Preparing" to OrderStatus.AWAITING_FULFILMENT
        OrderStatus.AWAITING_FULFILMENT -> "Shipping" to OrderStatus.AWAITING_SHIPMENT
        OrderStatus.AWAITING_SHIPMENT -> "Shipped" to OrderStatus.SHIPPED
        OrderStatus.SHIPPED -> "Shipped" to OrderStatus.SHIPPED
        else -> "Accept" to OrderStatus.PLACED
    }

    Column(
        modifier = Modifier
            .heightIn(min = 190.dp) // use heightIn to allow expansion
            .padding(8.dp)
            .fillMaxWidth()
    ) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .background(Color.White, shape = RoundedCornerShape(10.dp))
                .clip(RoundedCornerShape(10.dp))
                .padding(12.dp)
        ) {
            if (selectedOrderId.value == order._id) {
                AlertDialogue(
                    viewModel = alertViewModel
                ) {
                    Card(
                        modifier = Modifier
                            .fillMaxWidth()
                            .wrapContentHeight()
                            .background(Color.White, shape = RoundedCornerShape(16.dp)),
                        elevation = CardDefaults.cardElevation(defaultElevation = 4.dp),
                        colors = CardDefaults.cardColors(containerColor = Color.White),
                        shape = RoundedCornerShape(16.dp)
                    ) {
                        Column(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(16.dp),
                            horizontalAlignment = Alignment.CenterHorizontally
                        ) {
                            Box(
                                modifier = Modifier
                                    .height(40.dp)
                                    .width(40.dp)
                                    .padding(8.dp)
                                //.border(1.dp, color, shape = CircleShape)
                            ) {
                                Icon(
                                    Icons.Rounded.QuestionMark,
                                    contentDescription = "Confirmation",
                                    tint = ThemeColor.shared().PrimaryColor
                                )
                            }
                            Text(
                                text = localization().order.orderConfirmTitle,
                                fontSize = 18.sp,
                                style = TextStyle(fontWeight = FontWeight(600))
                            )
                            Box(
                                modifier = Modifier
                                    .fillMaxWidth().fillMaxHeight().weight(1f)
                                    .padding(top = 20.dp)
                            ) {
                                Text(
                                    text = localization().order.orderConfirmMessage,
                                    fontSize = 16.sp,
                                    textAlign = TextAlign.Center
                                )
                            }
                            TextInputField(
                                title = "Reason Description",
                                "Reason Description",
                                description.value
                            ) {
                                description.value = it
                            }
                            Row(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .height(60.dp)
                                    .padding(start = 8.dp, end = 8.dp)
                            ) {
                                Box(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .height(60.dp)
                                        .padding(top = 16.dp)
                                        .weight(0.5f)
                                ) {
                                    SecondaryButton(title = "Cancel", onClick = {
                                        CoroutineScope(Job() + Dispatchers.Default).launch {
                                            alertViewModel.repository.isAlertVisible.emit(false)
                                        }
                                    })
                                }
                                Box(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .height(60.dp)
                                        .padding(top = 16.dp)
                                        .weight(0.5f)
                                ) {
                                    DefaultButton(
                                        title = localization().button.doneButton,
                                        onClick = {
                                            orderViewModel.updateStatus(
                                                order,
                                                OrderStatus.CANCELLED,
                                                OrderReason.INVENTORY_ISSUE,
                                                description.value
                                            ) { isSuccess ->
                                                if (isSuccess) {
                                                    AppNavigator.shared().goBack()
                                                } else {
                                                    AlertHandler.shared().showAlert(
                                                        localization().order.orderAlertTitle,
                                                        localization().order.orderAlertMessage/*"Oops!", "Something went wrong"*/
                                                    )
                                                }
                                            }
                                            CoroutineScope(Job() + Dispatchers.Default).launch {
                                                alertViewModel.repository.isAlertVisible.emit(false)
                                            }
                                        }
                                    )
                                }
                            }
                        }
                    }
                }
            }
            Row {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                ) {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .clickable { onClick(order) },
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Box(
                            modifier = Modifier
                                .size(60.dp)
                                .background(Color.White, shape = RoundedCornerShape(10.dp))
                                .clip(RoundedCornerShape(10.dp))
                                .clickable { onClick(order) },
                            contentAlignment = Alignment.CenterStart,
                        ) {
                            ImageView(id = order.selectedBusinessID, order.BusinessID)
                        }
                        Spacer(modifier = Modifier.width(8.dp))
                        Column(
                            modifier = Modifier.weight(1f)
                        ) {
                            Text(
                                text = business?.Name ?: "",
                                fontSize = 16.sp,
                                fontWeight = FontWeight.SemiBold
                            )
                            Text(
                                text = AddressUtill().getAddressToDisplayInSingleLine(business?.Address),
                                fontSize = 12.sp,
                                color = Color.Gray
                            )
                            Text(
                                text = DateEngine().displayableDateTime(order.updatedAt),
                                fontSize = 12.sp,
                                color = Color.Gray
                            )
                        }
                        Text(
                            text = order.status?.name ?: "",
                            fontSize = 12.sp,
                            color = ThemeColor.shared().PrimaryColor,
                            modifier = Modifier.padding(start = 8.dp)
                        )
                    }

                    Spacer(modifier = Modifier.height(6.dp))
                    DottedLine()

                    // Summary Row
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .clickable { isExpanded = !isExpanded }
                            .background(
                                ThemeColor.shared().rowHeadingColor,
                                shape = RoundedCornerShape(6.dp)
                            )
                            .padding(8.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Text(
                            text = "${order.orderItems.count()} Item(s)",
                            modifier = Modifier.weight(2f),
                            fontWeight = FontWeight.Medium
                        )
                        Text(
                            text = "${
                                BusinessConfigHandler.shared()
                                    .getCurrencySymbol(order.pricing.currency)
                            } ${order.pricing.FinalPrice}",
                            modifier = Modifier.padding(end = 8.dp),
                            fontWeight = FontWeight.Bold
                        )
                        Icon(
                            imageVector = if (isExpanded) Icons.Default.ExpandLess else Icons.Default.ExpandMore,
                            contentDescription = null,
                            tint = ThemeColor.shared().PrimaryColor
                        )
                    }
                    // Order Items
                    if (isExpanded) {
                        Spacer(modifier = Modifier.height(4.dp))
                        LazyColumn(
                            modifier = Modifier
                                .fillMaxWidth()
                                .heightIn(max = 160.dp)
                                .background(ThemeColor.shared().defaultBakground)
                        ) {
                            items(order.orderItems.size) { index ->
                                val item = order.orderItems[index]
                                Row(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .padding(vertical = 4.dp, horizontal = 8.dp),
                                    horizontalArrangement = Arrangement.SpaceBetween
                                ) {
                                    Text(
                                        text = "${item.quantity} x ${item.product.Name}",
                                        fontSize = 13.sp,
                                        modifier = Modifier.weight(2f)
                                    )
                                    Text(
                                        text = "${
                                            BusinessConfigHandler.shared()
                                                .getCurrencySymbol(order.pricing.currency)
                                        } ${item.price?.FinalPrice}",
                                        fontSize = 13.sp,
                                        modifier = Modifier.align(Alignment.CenterVertically)
                                    )
                                }
                            }
                        }
                    }

                    Spacer(modifier = Modifier.height(12.dp))

                    // Action Buttons
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(bottom = 4.dp),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        SecondaryButton(
                            title = "Reject",
                            onClick = {
                                selectedOrderId.value = order._id
                                alertViewModel.showAlert()
                            },
                        )
                        DefaultButton(
                            title = orderStatusChangeTitle, onClick = {
                                orderViewModel.updateStatus(
                                    order,
                                    orderStatusChangeState
                                ) { isSuccess ->
                                    if (isSuccess) {
                                        AppNavigator.shared().goBack()
                                    } else {
                                        AlertHandler.shared().showAlert(
                                            localization().order.orderAlertTitle,
                                            localization().order.orderAlertMessage/*"Oops!", "Something went wrong"*/
                                        )
                                    }
                                }
                            }, modifier = Modifier.height(36.dp)
                        )
                    }
                }
            }
        }
    }


}